import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export default function GoogleCaptcha({
  siteKey,
  onVerify,
}) {
  return (
    <ReCAPTCHA
      sitekey={siteKey || process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}
      onChange={onVerify}
    />
  );
}

